import { useContext } from 'react';
import { InternalViewContext } from '../components/contexts/InternalViewContext';

export const useInternalViewContext = () => {
  const context = useContext(InternalViewContext);
  if (!context) {
    throw new Error(
      'useInternalViewContext must be used within an InternalViewProvider'
    );
  }
  return context;
};
